<template>
<div class="price-chart">
  <CryptoPriceChart
    :cryptoCurrency="props.cryptoCurrency"
    :fiatCurrency="props.fiatCurrency"
    :pricePageLink="linkToPricePage"
    :formattedPrice="formattedPrice"
    @fiatChanged="updateMarketInfo"
  />
  <MarketInformation
    :cryptoCurrency="props.cryptoCurrency"
    :fiatCurrency="selectedFiatCurrency"
    :marketInformation="marketInformation"
  />
</div>
</template>

<script setup lang="ts">
import {
  CryptoMarketInformation,
  PriceChartCryptoCurrency,
  PriceChartCurrency
} from "@kano/types/crypto-price-chart";
import { computed, ref } from "vue";
import { i18n } from "@kano/i18n";
import UrlGenerator from '@paybis/frontend-common-lib/src/services/url';
import MarketInformation from "@kano/components/CryptoPriceChart/MarketInformation.vue";
import { formatNumberStandard, CurrencyFormat } from "@kano/helpers/numberFormatter";
import CryptoPriceChart from "@kano/components/CryptoPriceChart/Chart/CryptoPriceChart.vue";
import { useMemoize } from "@vueuse/core";
import PricesClient from "@kano/services/clients/seo-client";

const props = defineProps<{
  cryptoCurrency: PriceChartCryptoCurrency,
  fiatCurrency: PriceChartCurrency,
  marketInformation: CryptoMarketInformation,
}>();

const selectedFiatCurrency = ref<PriceChartCurrency>(props.fiatCurrency);
const marketInformation = ref<CryptoMarketInformation>(props.marketInformation);

const formattedPrice = computed(() => formatNumberStandard(marketInformation.value?.price, i18n.locale,
    selectedFiatCurrency.value?.code, CurrencyFormat.symbol));
const linkToPricePage = computed(() => UrlGenerator.generate(`/price/${props.cryptoCurrency?.slug}/`, {}, i18n.locale));

const fetchMarketInfo = useMemoize(async (fiatCode) => {
  const { marketInfo } = await PricesClient.getDetails('CCCAGG', props.cryptoCurrency?.code, fiatCode);
  return marketInfo;
});
const updateMarketInfo = async (newFiatCurrency: PriceChartCurrency) => {
  selectedFiatCurrency.value = newFiatCurrency;
  marketInformation.value = await fetchMarketInfo(newFiatCurrency.code);
}
</script>